/* import __COLOCATED_TEMPLATE__ from './eflex-bs-pagination.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();